import parse from 'html-react-parser';
import Helmet from 'react-helmet';

import type { BasicProps } from 'quarks/interpolations/basic';

import RichText from 'components/RichText';

import type { ContentfulComponentIframeEmbedCode } from 'graphqlTypes';
import type { FC } from 'react';

interface EmbedCodeProps extends BasicProps {
  embedCode?: ContentfulComponentIframeEmbedCode | undefined;
  displayCode?: string | undefined;
}

const EmbedCode: FC<EmbedCodeProps> = ({ embedCode, displayCode }) => {
  if (!embedCode) {
    return null;
  }

  const code = embedCode;
  const innerCode = JSON.parse(code?.raw).content[0]?.content[0]?.value;
  if (displayCode === 'Head' && innerCode) {
    return <Helmet>{parse(innerCode)}</Helmet>;
  }

  return <RichText content={embedCode} />;
};

export default EmbedCode;
